import "../styles/default.scss";

import Tooltip from "@mui/material/Tooltip";
import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";
import { countLeaveTouchDelay } from "../lib/countLeaveTouchDelay";

const SquaberTooltip = ({
  title,
  rawTitle,
  placement = "bottom",
  children,
  translate,
  onClick
}) => {
  return (
    <Tooltip
      title={rawTitle ?? translate(title)}
      placement={placement}
      leaveTouchDelay={
        title ? countLeaveTouchDelay({ title: translate(title) }) : undefined
      }
      enterTouchDelay={0}
      classes={{
        tooltip: "squaber-tooltip"
      }}
      onClick={e => onClick?.(e)}
    >
      {children}
    </Tooltip>
  );
};

export default withTranslations(SquaberTooltip);
